
import styles from "./SearchCrawlerScheduler.module.css";
import { Button, Spinner, Modal} from "react-bootstrap";
import { useEffect, useState, useCallback, useRef } from "react";
import AGTable from "../../../../components/AGTable/AGTable";
import TimedAlert from "../../../../components/TimedAlert/TimedAlert";
import { deleteSearchCrawlSchedule, getSearchCrawlSchedules, kickoffBulkSearchCrawl } from "../../../../api/portalApi";
// import HorizontalNavbar from "../../../../components/HorizontalNavbar/HorizontalNavbar";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import SearchCrawlerSchedulerAddSchedule from "./SearchCrawlerSchedulerAddSchedule/SearchCrawlerSchedulerAddSchedule";
import { dayMap, toTitleCase } from "../../../../utilities/functions";
import { updateSearchCrawlSchedule } from "../../../../api/portalApi";

const SearchCrawlerScheduler = (props) => {
    // Data State
    const [jobs, setJobs] = useState();
    const [selectedJob, setSelectedJob] = useState();
    const [error, setError] = useState();
    const [alert, setAlert] = useState();
    const [scheduleObj, setScheduleObj] = useState();
    const gridRef = useRef();
    
    // UI State
    const [showAlert, setShowAlert] = useState(false);
    const [showKickoffModal, setShowKickoffModal] = useState(false);
    const [showDeleteSchedule, setShowDeleteSchedule] = useState(false);
    const [showEditSchedule, setShowEditSchedule] = useState(false);
    const [loading, setLoading] = useState(false);
    
    const userEmail = props.userEmail;
    const setActiveKey = props.setActiveKey;
    // const menuItems = [
    //     { key: 'viewJobs', label: 'View Jobs'},
    //     { key: 'addSchedule', label: 'Add Schedule'},
    // ];
    useEffect(()=> {
        // try{
        //     const timePart = selectedJob?.next_run_time?.split('T')[1]; // "12:00:00+10:00"
        //     const [hours, minutes] = timePart?.split(':');
            
        //     setScheduleObj({
        //         dayOfWeek: selectedJob?.day_of_week,
        //         day: selectedJob?.day,
        //         hour: hours,
        //         minute: minutes
        //     });
        // } catch (e) {
        //     return
        // }
        const time = selectedJob?.next_run_time.split("T")[1];
        setScheduleObj({
            dayOfWeek: selectedJob?.day_of_week ? selectedJob?.day_of_week.split(",").map((day) => ({
                value: dayMap[toTitleCase(day)],
                label: dayMap[toTitleCase(day)]
            })) : [{
                value: "Every day",
                label: "Every day"
            }],
            day: selectedJob?.day ? selectedJob?.day.split(",").map((day) => ({
                value: parseInt(day),
                label: day
            })) : [{
                value: "Every day",
                label: "Every day"
            }],
            hour: `${time?.substring(0,2)}:00`,
            minute: time?.substring(3,5),
        });
    }, [selectedJob]);

    const fetchJobs = useCallback(async() => {
        setLoading(true);
        try{
            const res = await getSearchCrawlSchedules();
            const data = res?.data?.data || res?.data
            setJobs(data);
            // setJobs(data?.map((job) => {
            //     return {
            //         ...job,
            //         payload: JSON.stringify(job?.payload),
            //     }
            // }));
        } catch (e){
            setError(e);
            setAlert(e?.response?.data?.message);
            setShowAlert(true);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchJobs()
    }, [fetchJobs]);

    const editSchedule = async() => {
        setShowEditSchedule(false);
        setLoading(true);
        try{
            const postData ={
                time: `${scheduleObj?.hour.split(":")[0]}:${scheduleObj?.minute}`,
                day_of_week: scheduleObj?.dayOfWeek.map((day) => day.value === "Every day" ? null : day?.value.slice(0,3)).join(","),
                day: scheduleObj?.day.map((day) => day.value === "Every day" ? null : day?.value).join(","),
                schedule_id: selectedJob?.schedule_id,
                payload: selectedJob?.payload?.map((job) => {
                    return {
                        vertical: job?.vertical,
                        match_source: job?.match_source,
                        department: job?.department,
                        search_banner: job?.search_banner,
                        result_banner: job?.result_banner,
                        search_brands: job?.search_brands,
                        result_brands: job?.result_brands,
                        sku_name_similarity_min: job?.sku_name_similarity_min,
                        brand_similarity_min: job?.brand_similarity_min,
                        max_results: job?.max_results,
                        client: job?.client,
                        data_source: job?.data_source,
                        tag: job?.tag,
                        created_by: job?.created_by
                    }
                })
            };
            const res = await updateSearchCrawlSchedule(postData);
            setError();
            setAlert(res?.data?.message);
            setShowAlert(true);
            fetchJobs();
            
        } catch (e){
            setError(e);
            setAlert(e?.response?.data?.message);
            setShowAlert(true);
        } finally {
            setLoading(false);
        }
        
    };

    const deleteSchedule = async() => {
        setLoading(true);
        try {
            const res = await deleteSearchCrawlSchedule(selectedJob?.schedule_id);
            setError();
            fetchJobs();
            setAlert(res?.data?.message);
        } catch (e) {
            console.error(e);
            setError(e);
            setAlert(e?.response?.data?.message);
        } finally {
            setSelectedJob();
            setShowAlert(true);
            setLoading(false);
        }

    };

    const kickoffJobs = async() => {
        setLoading(true);
        try{
            const data =selectedJob?.payload?.map((job) => {
                return {
                    ...job,
                    created_by: userEmail
                }
            })
            await kickoffBulkSearchCrawl(data);
            setActiveKey('kickedOffJobs');
        } catch (e){
            setError(e);
            setAlert(e?.response?.data?.message);
            setShowAlert(true);
        } finally {
            setLoading(false);
        }
    };

    return (
        
        <div>
            {/* Kickoff Schedule */}
            <Modal size="xl" show={showKickoffModal}>
                <Modal.Header closeButton onClick={() => setShowKickoffModal(false)}>
                    <Modal.Title>Are you sure you want to kickoff this schedule</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={styles.SearchCrawlerSchedulerModalBody}>
                        <span><strong>Schedule ID:</strong> {selectedJob?.schedule_id}</span>
                        <span><strong>Frequency:</strong> {selectedJob?.frequency}</span>
                        <span><strong>Jobs:</strong></span>
                        {selectedJob?.payload && 
                            <AGTable data={selectedJob?.payload}
                                columnsToHide={['tag','parent_sc_id', 'sc_id', 'data_source', 'client', 'vertical', 'match_type', 'status', 'spider_key', 'spider_name', 'created_at', 'created_by', 'input_file', 'job_id']}
                                editableFields={[...new Set(selectedJob?.payload?.flatMap(obj => Object.keys(obj)))]}
                                // key={selectedJob?.payload}
                            />
                        }
                    </div>
      
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowKickoffModal(false)}>
                        Close
                    </Button>
                    <Button variant="success" onClick={() => 
                        {
                            setShowKickoffModal(false);
                            kickoffJobs();
                        }}>
                        Kickoff jobs
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* Update Schedule */}
            <Modal show={showEditSchedule} size="xl">
                <Modal.Header closeButton onClick={() => setShowEditSchedule(false)}>
                    <Modal.Title>Update Search Crawl Jobs {selectedJob?.tag ? 'for ' + selectedJob?.tag : ''}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                        <div>
                            <SearchCrawlerSchedulerAddSchedule scheduleObj={scheduleObj} setScheduleObj={setScheduleObj}/>
                            <div style={{display: 'grid'}}>
                                <AGTable data={selectedJob?.payload}
                                gridRef={gridRef}
                                columnsToHide={['tag','parent_sc_id', 'sc_id', 'data_source', 'client', 'vertical', 'match_type', 'status', 'spider_key', 'spider_name', 'created_at', 'created_by', 'input_file', 'job_id']}
                                editableFields={[...new Set(selectedJob?.payload?.flatMap(obj => Object.keys(obj)))]}
                                // key={selectedJob?.payload}
                                />
                            </div>
                        </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" onClick={editSchedule}>
                        Update Schedule
                    </Button>
                    <Button variant="secondary" onClick={() => setShowEditSchedule(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* Delete Schedule */}
            <Modal size="xl" show={showDeleteSchedule}>
                <Modal.Header closeButton onClick={() => setShowDeleteSchedule(false)}>
                    <Modal.Title>Are you sure you want to delete this schedule</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={styles.SearchCrawlerSchedulerModalBody}>
                        <span><strong>Schedule ID:</strong> {selectedJob?.schedule_id}</span>
                        <span><strong>Frequency:</strong> {selectedJob?.frequency}</span>
                        <span><strong>Jobs:</strong></span>
                        {selectedJob?.payload && 
                            <AGTable data={selectedJob?.payload}
                                columnsToHide={['tag','parent_sc_id', 'sc_id', 'data_source', 'client', 'vertical', 'match_type', 'status', 'spider_key', 'spider_name', 'created_at', 'created_by', 'input_file', 'job_id']}
                                editableFields={[...new Set(selectedJob?.payload?.flatMap(obj => Object.keys(obj)))]}
                                key={selectedJob?.payload}
                            />
                        }
                    </div>
      
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteSchedule(false)}>
                        Close
                    </Button>
                    <Button variant="danger" onClick={() => 
                        {
                            deleteSchedule();
                            setShowDeleteSchedule(false);
                        }}>
                        Delete schedule
                    </Button>
                </Modal.Footer>
            </Modal>
            <TimedAlert
                message={alert}
                duration={2000}
                variant={error ? "danger" : "success"}
                show={showAlert}
                onClose={() => setShowAlert(false)}
            />
            {!loading && <div className={styles.SearchCrawlerScheduler}>
                <h4>Search Crawler Scheduling</h4>
                {jobs && <AGTable data={jobs.map((job) => {
                    return {
                        ...job,
                        payload: JSON.stringify(job?.payload),
                        actions: <div>
                            <IconButton disableRipple onClick={() => {
                                setSelectedJob(jobs?.filter(schedule => schedule?.schedule_id === job?.schedule_id)[0])
                                setShowKickoffModal(true);
                            }}>
                                <PlayCircleIcon/>
                            </IconButton >
                            <IconButton disableRipple onClick={() => {
                                setSelectedJob(jobs?.filter(schedule => schedule?.schedule_id === job?.schedule_id)[0])
                                setShowEditSchedule(true);
                            }}>
                                <EditIcon/>
                            </IconButton >
                            <IconButton disableRipple onClick={() => {
                                setSelectedJob(jobs?.filter(schedule => schedule?.schedule_id === job?.schedule_id)[0])
                                setShowDeleteSchedule(true);
                                // setSelectedPortalSchedule(portalScheduleData?.filter(schedule => schedule?.schedule_id === obj?.schedule_id)[0]);
                            }}>
                                <DeleteIcon/>
                            </IconButton >
                        </div>
                    }
                })} columnsToHide={["day", "day_of_week","payload"]}/>}
            </div>}
            {loading && <div className={styles.spinnerContainer}>
                <Spinner/>
            </div>}
        </div>

    )
};

export default SearchCrawlerScheduler;